/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import React, {useRef} from 'react';
import {AwesomeIcon, ElementPosition, ErrorType, showDialog, showSnackbar} from '@dvrd/dvr-controls';
import Attachment from "../../../../models/attachmentModel";
import {AppContext} from "../../../misc/appContext";
import {BolmateButton} from "../../../controls";

interface Props {
    onRefresh: (attachments: Attachment[]) => void;
    onUpload: VoidFunction;
}

export default function AttachmentUpload(props: Props) {
    const context = React.useContext(AppContext),
        ref = useRef<HTMLInputElement>(null);

    function onUpload(files: FileList | null) {
        const {account} = context.accountContext;
        if (!account) return;
        if (!files || files.length === 0) return;
        const isMultiple = files.length > 1;
        props.onUpload();
        Attachment.upload(files, account.id, (attachments: Attachment[], error: ErrorType) => {
            props.onRefresh(attachments);
            if (error) showDialog(error, `Upload (deels) mislukt: ${error}`);
            else {
                const msg = isMultiple ? 'De bijlages zijn geüploaded' : 'De bijlage is geüploaded';
                showSnackbar(msg);
            }
        });
    }

    function onClick() {
        ref.current?.click();
    }

    return <div>
        <BolmateButton onClick={onClick} label='Uploaden' ornaments={{
            element: <AwesomeIcon name='upload'/>,
            placement: ElementPosition.RIGHT
        }} secondary/>
        <input type="file" style={{display: "none"}} ref={ref}
               onChange={event => onUpload(event.currentTarget.files)} multiple/>
    </div>;
}